import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Capacitor } from '@capacitor/core';
import { getAnalytics } from 'firebase/analytics';
import { app } from '../lib/firebase';
import { debug } from '../utils/debug';
import { DEBUG_MODE } from '../config';

let analyticsInitialized = false;

export const initializeAnalytics = async () => {
  if (analyticsInitialized) return;
  try {
    if (Capacitor.isNativePlatform()) {
      // For native platforms, Capacitor Firebase plugin handles setup automatically via google-services.json
      await FirebaseAnalytics.setEnabled({ enabled: true });
    } else {
      // For the web platform, ensure standard Firebase Analytics is instantiated
      getAnalytics(app);
    }
    analyticsInitialized = true;
  } catch (error) {
    console.warn('Analytics initialization failed/skipped:', error);
  }
};

export const logEvent = async (name: string, params?: Record<string, any>) => {
  try {
    if (DEBUG_MODE) {
      debug.log(`[Analytics] Event: ${name}`, params || {});
    }
    await FirebaseAnalytics.logEvent({ name, params: params || {} });
  } catch (error) {
    console.warn(`Failed to log event ${name}:`, error);
  }
};

export const logScreenView = async (screenName: string, screenClassOverride?: string) => {
  try {
    if (DEBUG_MODE) {
      debug.log(`[Analytics] Screen View: ${screenName}`, { screenClassOverride });
    }
    
    if (Capacitor.isNativePlatform()) {
      await FirebaseAnalytics.setCurrentScreen({ 
        screenName, 
        screenClassOverride: screenClassOverride || screenName 
      });
    } else {
      // GA4 Web uses 'page_view' events rather than setScreenName
      await FirebaseAnalytics.logEvent({
        name: 'page_view',
        params: {
          page_path: screenName,
          page_title: screenClassOverride || screenName
        }
      });
    }
  } catch (error) {
    console.warn(`Failed to set screen name ${screenName}:`, error);
  }
};

export const setUserAnalyticsId = async (userId: string | null) => {
  try {
    await FirebaseAnalytics.setUserId({ userId });
  } catch (error) {
    console.warn(`Failed to set user id:`, error);
  }
};
